import React from 'react';
import useAuth from '../../hooks/useAuth';
import PublicNavbar from './PublicNavbar';
import PrivateNavbar from './PrivateNavbar';

// Ana Navbar bileşeni, kullanıcı durumuna göre doğru navbar'ı gösterir
const Navbar = () => {
  const { user } = useAuth();

  // isAuthenticated değerine göre uygun navbar'ı göster
  return user ? <PrivateNavbar /> : <PublicNavbar />;
};

export default Navbar;